<script>
import ElTable from 'element-ui/lib/table'

export default {
  // 保留 Table 的同一实例：列注册、固定列、selection 及 ref 方法依赖此关系。
  name: 'ElTable',
  extends: ElTable,
  props: {
    minWidth: { type: [Number, String], default: null },
    emptyText: { type: String, default: '暂无数据' },
    tooltipEffect: { type: String, default: 'dark' }
  },
  render (h) {
    const vnode = ElTable.render.call(this, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-table', 'admin-data-table']
    const minWidth = typeof this.minWidth === 'number' ? `${Math.max(0, this.minWidth)}px` : this.minWidth
    vnode.data.style = [vnode.data.style, { '--admin-table-min-width': minWidth || 'var(--ui-admin-table-min-width)' }]
    return vnode
  }
}
</script>
